import { useSelector } from 'react-redux';
import { selectTopAuctionBetPosition } from '../../../../../../../../../../../selectors/betPosition';
import { selectIsAuctionEnabled } from '../../../../../../../../../../../selectors/auction';
import { getTopBetServiceTitle } from '../../ServiceContainer/utils';
import { useService } from '../../ServiceContainer/hooks';
import { EServiceId } from '../../../../../../../../../../../types/reducers/publishTerms';
import {
  selectCurrentBet,
  selectIsTopServiceUnavailable,
} from '../../../../../../../../../../../reducers/v2/promotion/selectors';

export const useTopService = () => {
  const { price } = useService(EServiceId.top);
  const topAuctionBetPosition = useSelector(selectTopAuctionBetPosition);
  const isTopServiceUnavailable = useSelector(selectIsTopServiceUnavailable);
  const isAuctionEnabled = useSelector(selectIsAuctionEnabled);
  const currentBet = useSelector(selectCurrentBet);

  const topBetServiceTitle = getTopBetServiceTitle(currentBet, price);

  // На мобилках позиция отображается внутри PromotionSectionContainer
  const showBetPosition = Boolean(topAuctionBetPosition);
  const showPrice = Boolean(isTopServiceUnavailable || !isAuctionEnabled);

  return {
    showBetPosition,
    showPrice,
    topBetServiceTitle,
    isTopServiceUnavailable,
    topAuctionBetPosition,
  };
};
